export default "__VITE_PUBLIC_ASSET__ed850032__"